<template>
    <div>
    <div :disabled="bgDisabled" id="header">
        <a class="visually-hidden-focusable" hidden href="#main-content"
            >Skip to main content</a
        >
  <div class="container"></div>
        <div class="signin-btn">
            <button id="btn_sign_in" v-if="this.$store.state.Auth.user === null" @click="doLogin" class="btn  signin-btn " aria-label="Single Sign On">
            Sign in
            </button>

            <div class="dropdown logout-dropdown"  style="float:right !important;" v-else>
                <button id="btn_sign_out" @click="doLogout" class="btn  signout-btn" aria-label="Single Sign Out">
                    Sign out
                </button>
                <a v-if="JSON.parse(this.$store.state.Auth.user) && JSON.parse(this.$store.state.Auth.user).userLogo" class="p-2" style="margin-top:4px" id="logout-dropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <img :src="JSON.parse(this.$store.state.Auth.user).userLogo" width="40" height="40" class="rounded-circle green-border" alt="user icon">
                </a>
                <a v-else class="p-2" style="margin-top:4px" aria-label="Logout" id="logout-dropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <em class="fas fa-portrait icon-style" width="40" height="40" alt="user icon"></em>
                </a>
                <a>
                    Hi, {{JSON.parse(this.$store.state.Auth.user).fullName}}
                </a>
            </div>
        </div>
        <nav class="navbar navbar-expand-md navbar-dark orginal-navbar" role="navigation ">
            <div class="container container-md container-sm">
                <a
                    class="navbar-brand"
                    href="https://financialdataexchange.org/FDX/FDX/Default.aspx?hkey=bd839735-ebf5-426a-91f9-8334cbae1438"
                >
                    <img
                        id="financial_logo"
                        src="@/assets/FDX900.png"
                        alt="Financial Data Exchange logo"
                        style="max-width: auto; height: 270%"
                    />
                    <img
                    id="fdx_logo"
                    src="@/assets/FDX_Icon.png"
                    alt="Financial Data Exchange logo"
                    style="max-width: auto; height: 200%"
                />
                </a>
                <img
                    id="mobileMenuBtn"
                    src="@/assets/MobileIcon-Menu.png"
                    class="navbar-toggler"
                    type="button"
                    @click="toggleMobileMenu"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    alt="mobile icon"
                >


                <div
                    class="collapse navbar-collapse justify-content-end"
                    id="navbarSupportedContent"
                    :class="{ show: showMobileMenu }"
                >
                    <ul class="navbar-nav mr-auto">
                        <li class="nav-item">
                            <a
                                class="nav-link"
                                href="https://financialdataexchange.org/FDX/FDX/About/About-FDX.aspx?hkey=dffb9a93-fc7d-4f65-840c-f2cfbe7fe8a6"
                                >ABOUT</a
                            >
                        </li>
                        <li class="nav-item dropdown " :class=" this.showDropdownFdxFeed === true?'showDropdownEvent':''">
                            <a class="nav-link" href="https://financialdataexchange.org/FDX/FDX/News/FDX-News.aspx?hkey=018fdd8f-d23e-407c-8732-810ca910f57c">FDX FEED</a>
                            <div
                                class="dropdown-menu" @mouseover="dropdownOver('fdxFeed')" @mouseleave="dropdownLeave('fdxFeed')"
                            >
                                <a
                                    class="dropdown-item"
                                    href="https://financialdataexchange.org/FDX/FDX/News/Announcements-home.aspx?hkey=187c65e9-fdfe-4d7b-8cfb-d88060e9b731"
                                    >Blog</a
                                >
                                <a
                                    class="dropdown-item"
                                    href="https://financialdataexchange.org/FDX/FDX/News/Spotlights-home.aspx?hkey=46311498-fd75-4950-a1e6-b61f448d527a"
                                    >Member Spotlights</a
                                >
                                <a
                                    class="dropdown-item"
                                    href="https://financialdataexchange.org/FDX/FDX/News/Press-Releases-home.aspx?hkey=4120f9d9-6265-4ab7-a19b-9e6ace6d36ab"
                                    >Press Releases</a
                                >
                            </div>
                        </li>

                        <li class="nav-item dropdown " :class=" this.showDropdownResources === true?'showDropdownResources':''">
                            <a
                                class="nav-link"
                                href="https://financialdataexchange.org/FDX/The%20Consortium/FDX/The-Consortium/Members.aspx?hkey=362ecd23-b752-48aa-b104-a99e916276c8"
                                >RESOURCES</a
                            >
                            <div
                                class="dropdown-menu" @mouseover="dropdownOver('resource')" @mouseleave="dropdownLeave('resource')"
                            >
                                <a
                                    class="dropdown-item"
                                    :href="this.URL ==='https://onboarding.financialdataexchange.org'?'https://registry.financialdataexchange.org/':this.URL==='https://onboarding-staging.financialdataexchange.org'?'https://staging-registry.financialdataexchange.org/':'https://registry-dev.financialdataexchange.org/'" target="_blank"
                                    >Registry</a
                                >
                                <a
                                    class="dropdown-item"
                                    href="https://financialdataexchange.org/FDX/FDX/White-Papers-Guides.aspx?hkey=e084d471-4a70-4bf2-abbe-8835c441fca0"
                                    >White Papers & Guides</a
                                >
                                <a
                                    class="dropdown-item"
                                    href="https://financialdataexchange.org/FDX/FDX/US-Tax/US-Tax-Forms.aspx?hkey=00bae613-7ec8-4c93-8e37-4712f09ae255"
                                    >US Tax Data</a
                                >
                            </div>
                        </li>
                        <li class="nav-item dropdown" :class=" this.showDropdownEvent === true?'showDropdownEvent':''">
                            <a
                                class="nav-link"
                                href="https://financialdataexchange.org/FDX/FDX/Events/Events_List.aspx?DisplayAreaOptions=No&hkey=304c3960-e79b-47b9-9615-37e887dae624"
                                >EVENTS</a
                            >
                            <div
                                class="dropdown-menu" @mouseover="dropdownOver('event')" @mouseleave="dropdownLeave('event')"
                            >
                                <a
                                    class="dropdown-item"
                                    href="https://financialdataexchange.org/FDX/FDX-Global-Summit.aspx?hkey=c2f14655-b4ce-44dd-94ab-61c7d32a0b6e"
                                    >FDX Spring Global Summit</a
                                >
                                <a
                                    class="dropdown-item"
                                    href="https://financialdataexchange.org/FDX/FDX/Events/Webinars.aspx?hkey=4adbef63-b922-4a10-9133-ff7aed32e58d"
                                    >Webinars</a
                                >
                            </div>
                        </li>
                        <li class="nav-item dropdown" :class=" this.showDropdownGetStarted === true?'showDropdownGetStarted':''">
                            <a
                                class="nav-link "
                                href="https://financialdataexchange.org/FDX/FDX/Membership/Benefits.aspx?hkey=3537db1b-f8eb-4c56-aeac-b492c89a2318"
                                >GET STARTED</a
                            >
                            <div
                                class="dropdown-menu" @mouseover="dropdownOver('getStarted')" @mouseleave="dropdownLeave('getStarted')"
                            >
                                <a
                                    class="dropdown-item"
                                    href="https://financialdataexchange.org/FDX/FDX/Membership/Benefits.aspx?hkey=feb79818-c828-4e53-84d6-b23c5bf82d73"
                                    >Benefits</a
                                >
                                <a
                                    class="dropdown-item"
                                    href="#"
                                    >Participation Options</a
                                >
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>

        <hr />
    </div>

            <div
                class="collapse navbar-collapse justify-content-end navbar navbar-expand-md navbar-dark mobile-navbar"
                id="navbarSupportedContent"
                :class="{ show: showMobileMenu }"
                v-if="showMobileMenu === true"
                role="navigation"
            >
                <div class="signin-btn-mobile">
            <button id="btn_sign_in_mobile" v-if="this.$store.state.Auth.user === null" @click="doLogin" class="btn  mobile-signin-btn " aria-label="Single Sign On">
            Sign in
            </button>

            <div class="dropdown logout-dropdown-mobile"  style="float:left !important;" v-else>
                <button id="btn_sign_out_mobile" @click="doLogout" class="btn  mobile-signout-btn" aria-label="Single Sign Out">
                    Sign out
                </button>
                <div class="profile-mobile">
                    <a v-if="JSON.parse(this.$store.state.Auth.user) && JSON.parse(this.$store.state.Auth.user).userLogo" class="p-2" style="margin-top:4px" id="logout-dropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <img :src="JSON.parse(this.$store.state.Auth.user).userLogo" width="40" height="40" class="rounded-circle green-border" alt="user icon">
                    </a>
                    <a v-else class="p-2" style="margin-top:4px" aria-label="Logout" id="logout-dropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <em class="fas fa-portrait icon-style" width="40" height="40" alt="user icon"></em>
                    </a>
                    <a class="p-2">
                        Hi, {{JSON.parse(this.$store.state.Auth.user).fullName}}
                    </a>

                </div>

            </div>
        </div>


                <ul class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <a
                            class="nav-link"
                            href="https://financialdataexchange.org/FDX/FDX/About/About-FDX.aspx?hkey=dffb9a93-fc7d-4f65-840c-f2cfbe7fe8a6"
                            >ABOUT</a
                        >
                    </li>
                    <li class="nav-item" :class="showFdxFeedMenu === true?'FdxFeed-nav-item':''">
                        <div class="nav-link "  :class="showFdxFeedMenu === true?'FdxFeed-nav-link':''">
                            <a href="https://financialdataexchange.org/FDX/FDX/News/FDX-News.aspx?hkey=018fdd8f-d23e-407c-8732-810ca910f57c">FDX FEED</a>

                              <img id="down_arrow" v-if="showFdxFeedMenu === false" src="@/assets/Icon_menu_arrow.png" alt="down arrow" @click="toggleArrow('showFdxFeedMenu')"/>

                              <img id="up_arrow" v-else src="@/assets/Icon_menuarrow_up.png" alt="up arrow" @click="toggleArrow('showFdxFeedMenu')"/>

                          </div>
                          <ul id="fdx_feed_items" v-if="showFdxFeedMenu === true" :class="showFdxFeedMenu === true?'FdxFeed-ul':''">
                              <li><a

                                href="https://financialdataexchange.org/FDX/FDX/News/Announcements-home.aspx?hkey=187c65e9-fdfe-4d7b-8cfb-d88060e9b731"
                                >Blog</a
                            >
                            </li>
                              <li>
                            <a

                                href="https://financialdataexchange.org/FDX/FDX/News/Spotlights-home.aspx?hkey=46311498-fd75-4950-a1e6-b61f448d527a"
                                >Member Spotlights</a
                            >
                            </li>
                              <li>
                            <a
                               href="https://financialdataexchange.org/FDX/FDX/News/Press-Releases-home.aspx?hkey=4120f9d9-6265-4ab7-a19b-9e6ace6d36ab"
                                >Press Releases</a>
                            </li>
                            </ul>
                    </li>

                    <li class="nav-item" :class="showResourcesMenu === true?'resource-nav-item':''">
                        <div class="nav-link "
                        @click="toggleArrow('showResourcesMenu')"
                        :class="showResourcesMenu === true?'resource-nav-link':''" >
                        <a
                        href="https://financialdataexchange.org/FDX/The%20Consortium/FDX/The-Consortium/Members.aspx?hkey=362ecd23-b752-48aa-b104-a99e916276c8"
                        >RESOURCES</a
                    >

                              <img id="down_arrow" v-if="showResourcesMenu === false" src="@/assets/Icon_menu_arrow.png" alt="down arrow"/>

                              <img id="up_arrow" v-else src="@/assets/Icon_menuarrow_up.png" alt="up arrow"/>

                          </div>
                          <ul id="resources_items" v-if="showResourcesMenu === true" :class="showResourcesMenu === true?'resource-ul':''">
                              <li><a   :href="this.URL ==='https://onboarding.financialdataexchange.org'?'https://registry.financialdataexchange.org/':this.URL==='https://onboarding-staging.financialdataexchange.org'?'https://staging-registry.financialdataexchange.org/':'https://registry-dev.financialdataexchange.org/'" target="_blank">Registry</a></li>
                              <li><a  href="https://financialdataexchange.org/FDX/FDX/White-Papers-Guides.aspx?hkey=e084d471-4a70-4bf2-abbe-8835c441fca0">White Papers & Guides</a></li>
                              <li><a  href="https://financialdataexchange.org/FDX/FDX/US-Tax/US-Tax-Forms.aspx?hkey=00bae613-7ec8-4c93-8e37-4712f09ae255">US Tax Data</a></li>
                            </ul>
                    </li>
                    <li class="nav-item"  :class="showEventMenu === true?'event-nav-item':''">
                        <div class="nav-link "
                        @click="toggleArrow('showEventMenu')"
                        :class="showEventMenu === true?'event-nav-link':''">
                        <a href="https://financialdataexchange.org/FDX/FDX/Events/Events_List.aspx?DisplayAreaOptions=No&hkey=304c3960-e79b-47b9-9615-37e887dae624"
                        >EVENTS</a
                    >

                            <img id="down_arrow" v-if="showEventMenu === false" src="@/assets/Icon_menu_arrow.png" alt="down arrow"/>

                            <img id="up_arrow" v-else src="@/assets/Icon_menuarrow_up.png" alt="up arrow"/>

                        </div>
                        <ul id="event_items" v-if="showEventMenu === true"  :class="showEventMenu === true?'event-ui':''">
                            <li><a

                                href="https://financialdataexchange.org/FDX/FDX-Global-Summit.aspx?hkey=c2f14655-b4ce-44dd-94ab-61c7d32a0b6e"
                                >FDX Spring Global Summit</a
                            >
                            </li>
                            <li>
                            <a

                                href="https://financialdataexchange.org/FDX/FDX/Events/Webinars.aspx?hkey=4adbef63-b922-4a10-9133-ff7aed32e58d"
                                >Webinars</a></li>

                          </ul>
                      </li>
                    <li class="nav-item" :class="showGetStartedMenu === true?'getStarted-nav-item':''">
                        <div class="nav-link " @click="toggleArrow('showGetStartedMenu')" :class="showGetStartedMenu === true?'getStarted-nav-link':''">
                            <a
                                href="https://financialdataexchange.org/FDX/FDX/Membership/Benefits.aspx?hkey=3537db1b-f8eb-4c56-aeac-b492c89a2318"
                                >GET STARTED</a
                            >
                              <img id="down_arrow" v-if="showGetStartedMenu === false" src="@/assets/Icon_menu_arrow.png" alt="down arrow"/>

                              <img id="up_arrow" v-else src="@/assets/Icon_menuarrow_up.png" alt="up arrow"/>

                          </div>
                          <ul id="get_started_items" v-if="showGetStartedMenu === true" :class="showGetStartedMenu === true?'getStarted-ui':''">
                              <li>
                                <a

                                href="https://financialdataexchange.org/FDX/FDX/Membership/Benefits.aspx?hkey=feb79818-c828-4e53-84d6-b23c5bf82d73"
                                >Benefits</a>
                            </li>
                              <li>
                                <a
                                href="#"
                                >Participation Options</a>
                            </li>

                            </ul>
                    </li>
                </ul>
            </div>
</div>
</template>
<script>
import { mapMutations, mapActions } from "vuex";
export default {
    name: "HeaderComponent",
    data() {
        return {
            showMobileMenu: false,
            bgDisabled: false,
            showDownArrow: true,
            showEventMenu: false,
            showResourcesMenu: false,
            showGetStartedMenu: false,
            showFdxFeedMenu: false,
            URL : window.location.origin,
            showDropdownEvent:false,
            showDropdownResources: false,
            showDropdownGetStarted: false,
            showDropdownFdxFeed: false,
        };
    },
    created(){
console.log(this.URL);
    },
    methods: {
        ...mapMutations([
            "setUserRole",
            "setUser",
            "setCallbackURL",
            "setPopup",
        ]),
        ...mapActions([
            "updateToken",
            "getCountries",
            "getEnumTypes",
        ]),
        popup(popup) {
            this.setPopup(popup);
        },
        doLogin() {
            this.$router.push("/login");
        },
        doLogout() {
            this.$router.push({path: "/logout"});
        },

        toggleMobileMenu() {
            this.showMobileMenu = !this.showMobileMenu;
        },
        disablebg(value) {
            this.bgDisabled = value;
        },
        toggleArrow(type) {
            if (type === 'showEventMenu') {
                this.showEventMenu = !this.showEventMenu;
                this.showResourcesMenu = false;
                 this.showFdxFeedMenu = false;
                  this.showGetStartedMenu= false;

            }
            else if (type === 'showGetStartedMenu') {
                this.showGetStartedMenu = !this.showGetStartedMenu;
                this.showEventMenu =  false;
                this.showResourcesMenu = false;
                this.showFdxFeedMenu = false;

            } else if (type === 'showResourcesMenu') {
                this.showResourcesMenu = !this.showResourcesMenu;
                this.showEventMenu =  false;
                this.showGetStartedMenu = false;
                this.showFdxFeedMenu = false;
            }
            else if (type === 'showFdxFeedMenu') {
                this.showFdxFeedMenu = !this.showFdxFeedMenu;
                this.showEventMenu =  false;
                this.showGetStartedMenu = false;
                this.showResourcesMenu = false;
            }
        },
        dropdownOver(type) {

            if(type==='event'){
                this.showDropdownEvent = true;
            }
            else if(type=== 'resource'){
                this.showDropdownResources = true;
            }
            else if(type === 'getStarted'){
                this.showDropdownGetStarted = true;
            }
            else if(type === 'fdxFeed'){
                this.showDropdownFdxFeed = true;
            }

        },
        dropdownLeave(type) {
            if(type ==='event'){
                this.showDropdownEvent = false;
            }
            else if(type === 'resource'){
                this.showDropdownResources = false;
            }
            else if(type === 'getStarted'){
                this.showDropdownGetStarted = false;
            }
            else if(type === 'fdxFeed'){
                this.showDropdownFdxFeed = false;
            }
        }
    },

};
</script>
<style scoped>
#event_items ,
#get_started_items ,
#resources_items ,
#fdx_feed_items{
    display: block !important;
    float:none !important;
    margin-top: 0px !important;
    color:#fff !important;
    list-style: none;

}
.signin-btn-mobile {
    position: relative;
}

.signin-btn-mobile::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 10px;
    right: 10px;
    top: 40px;
    height: 1px;
    background-color: #FFF;
}
#event_items li a,
#get_started_items li a ,
#resources_items li a ,
#fdx_feed_items li a{
    color:#fff !important;
    margin-bottom:  10px !important;

}
#event_items li,
#get_started_items li  ,
#resources_items li  ,
#fdx_feed_items li  {
    color:#fff !important;
    font-size: 14px !important;
    margin-bottom:  10px !important;
    margin-left: 4% !important;

}
#header {
    background: linear-gradient(0deg, #ffffff 58.2%, #e6e6e6 100%);
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
}

hr {
    border: 1px solid #d8d8d8;
}

ul {
    align-items: center;
    float: right;
    margin-top: 40px;
    margin-bottom: -10px;
    margin-right: -135px !important;
}
#down_arrow , #up_arrow{
    position: absolute;
    right: 25px;

}
.dropdown {
    position: relative;
    display: inline-block;
    outline: none !important;
    border: none !important;
}

.dropdown-menu {
    display: none;
    position: absolute;
    z-index: 1;
    background-color: #1978a0;
    outline: none !important;
    border: none !important;
    margin-top: -1px !important;
}

.dropdown-item {
    color: #ffffff;
    background-color: #1978a0;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0px;
    padding: 10px 0;
    padding-left: 15px !important;
    padding-right: 15px !important;
    outline: none !important;
    border: none !important;
}

.dropdown .dropdown-menu {
    -webkit-transition: all 1s;
    -moz-transition: all 1s;
    -ms-transition: all 1s;
    -o-transition: all 1s;
    transition: all 0.3s;
    max-height: 0;
    display: block;
    overflow: hidden;
    opacity: 0;
}

.dropdown:hover .dropdown-menu {
    display: block;
    max-height: 300px;
    opacity: 1;
}

.signin-btn {
    color: #0f8575 !important;
    background-color:transparent;
    border: 0;
    float: right;
    padding: 10px;
    margin-right: 50px;
    font-size: medium;
}

.signin-btn:hover,.signin-btn:focus,.signout-btn:hover, .signout-btn:focus {
    text-decoration-line: underline;
    border:none !important;
    outline: none !important;
    padding-bottom: 0px !important;
    box-shadow: none !important;

}
.signout-btn {
    color: #0f8575 !important;
    background-color:transparent;
    border: 0;
    font-size: medium;
}


.nav-link {
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0px;
    color: #5A7D95 !important;
    padding: 10px 0;
    padding-left: 15px !important;
    padding-right: 15px !important;
}
.showDropdownEvent,.showDropdownResources,
.showDropdownGetStarted,
.showDropdownFdxFeed{
    display: block;
    max-height: 300px;
    opacity: 2;
    background-color:  #1978a0 !important;
    color:#FFF !important;
}
.showDropdownEvent >a, .showDropdownResources >a,
.showDropdownGetStarted >a,
.showDropdownFdxFeed >a{
    color:#FFF !important;
}
li a:hover:not(.active) {
    color: #ffffff !important;
    background-color: #1978a0;
}
.navbar-toggler-icon {
    width: 2.5em !important;
    height: 2.5em !important;
}

.nav-item a.active {
    color: #ffffff !important;
    background-color: #1978a0;
}
#fdx_logo{
    display:none;
}
.mobile-navbar{
    display: none !important;
}
#btn_sign_in_mobile{
    float: left;
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0;
    color: #fff !important;
    background-color:transparent;
    border: 0;
    padding: 10px;

}
#btn_sign_in_mobile:active , #btn_sign_in_mobile:focus{
    outline: none !important;
    border: none !important;
    background-color: none !important;
    box-shadow: none !important;

}

.FdxFeed-nav-item,
.getStarted-nav-item,
.resource-nav-item,
.event-nav-item{
    background-color: rgb(20, 87, 115);
    width: 100vw !important;
    padding-left: 0 !important;
}
.FdxFeed-nav-link ,
.resource-nav-link,
.getStarted-nav-link,
.event-nav-link{
    float: left !important;
}
.event-nav-link a:hover,
.getStarted-nav-link a:hover
.FdxFeed-nav-link a:hover ,
.resource-nav-link a:hover{
    background-color: rgb(20, 87, 115) !important;
}
.resource-nav-item ul li{
    float:none !important;
    padding: 0px !important;
    width:100% !important;
    max-width:350px !important;
    text-align: start;

}
.FdxFeed-nav-item ul li{
    float:none !important;
    padding:0px !important;
    width:100% !important;
    max-width:250px !important;
    text-align: start;
}
.getStarted-nav-item ul li{
    float:none !important;
    padding:0px !important;
    width:100% !important;
    max-width:100px !important;
    text-align: start;
}
.event-nav-item ul li{
    float:none !important;
    padding:0px !important;
    width:100% !important;
    max-width:400px !important;
    text-align: start;
}
.resource-nav-item ul li a{
    text-decoration: none !important;
    margin-left: 202px !important;
}
.FdxFeed-nav-item ul li a{
    margin-left: 130px !important;
    text-decoration: none !important;
}
.getStarted-nav-item ul li a{
    margin-left: 210px !important;
    text-decoration: none !important;
}
.event-nav-item ul li a{
    margin-left: 175px !important;
    text-decoration: none !important;
}
.getStarted-nav-item ul li a:hover,
.event-nav-item ul li a:hover,
.FdxFeed-nav-item ul li a:hover ,
.resource-nav-item ul li a:hover{
    background-color:  rgb(20, 87, 115) !important;
}
.profile-mobile{
    display: block !important;
    position: absolute !important;
    left: 70px !important;
    width: 200% !important;
    top: 15px;
}
/* Media queries for different breakpoints */
@media (max-width: 1674px) {
    /* Styles specific to max-width: 1674px */
    .nav-item a.active {
        width: fit-content;
    }
}

@media (max-width: 1200px) {
    /* Styles specific to max-width: 1200px */
    .dropdown-menu.show {
        display: table-cell;
    }
}
@media (max-width: 992px) {
    /* Styles specific to max-width: 992px */
    .navbar-brand img {
        height: 200% !important;
    }
    .navbar-nav .nav-link,
    .dropdown-menu .dropdown-item {
        font-size: 12px !important;
    }

}

@media (max-width: 768px) {
    /* Styles specific to max-width: 768px */
    .navbar-brand img {
        height: 180% !important;
    }
    .navbar-nav .nav-link,
    .dropdown-menu .dropdown-item {
        font-size: 12px !important;
    }
    .dropdown-item{
        padding: 5px 9px;
    }
    #mobileMenuBtn {
        margin-left: 15px !important;
        margin-right: 15px !important;
    }
    .navbar .container,
    .navbar .container-fluid,
    .navbar .container-lg,
    .navbar .container-md,
    .navbar .container-sm,
    .navbar .container-xl {
        justify-content: flex-start;
    }
}

@media (max-width: 767px) {
    .mobile-navbar {
        display: block !important;
        padding-right: 0px !important;
        padding-left: 0px !important;
        background-color: #1978a0;
        color: #fff;
        position: absolute;
        left: 0;
        width: 100%;
        z-index: 1;
        top:80px;
        }
    .mobile-signout-btn{
        text-transform: uppercase;
        color: #fff;
        padding-right: 0px !important;
        padding-bottom: 0px !important;
        padding-top:15px !important;

    }
    .orginal-navbar .container>.navbar-collapse,.orginal-navbar .container>.navbar-header{
        display: none !important;
    }
    .navbar #financial_logo{
        display:none !important;

    }
    .navbar-brand #fdx_logo{
        display:block;
        height: 260% !important;
        position: absolute;
        max-width: 55px !important;
        max-height: 55px !important;
        bottom:-10px !important;
        left:20px !important;
    }
    .navbar-nav .nav-link, .dropdown-menu .dropdown-item {
        font-size: 16px !important;
        color:white !important;

    }
    .navbar-nav .nav-link img{
        cursor: pointer;
    }
    .navbar-nav .nav-link a{
        color: #fff !important;
        text-decoration: none;
    }
    .navbar-nav .nav-link a:hover{
        background-color: none !important;
    }
    /* Styles specific to max-width: 767px */
    ul {

        float: left !important;
        margin-bottom: 5px;
        align-items: start!important;
        margin-left: -80px !important;
        margin-right: 0px !important;

    }
    .container>.navbar-collapse, .container>.navbar-header {

        background-color: #1978a0;
        opacity: 45% !important;

    }
    .dropdown-menu {
        display: block;
        position: relative;
        min-width: 20px !important;

    }
    .signin-btn,
    .signout-btn {
        display: none;
    }
    #mobileMenuBtn {
        position:absolute;
        float:right;
        top: 25px;
        right:10px;
        max-width: 100px !important;
        max-height: 100px !important;


    }
    #event_items {
        padding: 0px !important;
        margin-left: -190px !important;
    }

    #get_started_items {
        padding: 0px !important;
        margin-left: -230px !important;

    }

    #resources_items {
        padding: 0px !important;
        margin-left: -220px !important;
    }

    #fdx_feed_items {
        padding: 0px !important;
        margin-left: -145px !important;
    }
}

@media (max-width: 600px) {
    /* Styles specific to max-width: 600px */

    #fdx_feed_items[data-v-61dd7a3d] {
        padding: 0px !important;
        margin-left: -144!important;
    }

    .navbar-brand img {
        height: 140% !important;
    }
    .navbar-nav .nav-link,
    .dropdown-menu .dropdown-item {
        font-size: 14px !important;
    }

    .dropdown-menu {
        right: 0px !important;
        left: 0px;
        min-width: 120px !important;
    }
    .navbar-toggler-icon {
        width: 1.5em !important;
        height: 1.5em !important;
    }
}

@media (max-width: 576px) {
    /* Styles specific to max-width: 576px */
    .navbar-brand img {
        height: 130% !important;
    }
    #event_items {
        margin-left: -180px !important;
    }

    #get_started_items {
        margin-left: -220px !important;

    }

    #resources_items {
        margin-left: -209px !important;
    }

    #fdx_feed_items {
        margin-left: -138px !important;
    }
}

@media (max-width: 378px) {
    /* Styles specific to max-width: 378px */
    .navbar-brand img {
        height: 120% !important;
    }
    .logout-dropdown {
        font-size: 16px !important;
        margin-right: -20px !important;
    }
}

@media (max-width: 320px) {
    /* Styles specific to max-width: 320px */
    .navbar-brand img {
        height: 120% !important;
        padding: 0px !important;
    }
    .navbar-nav .nav-link,
    .dropdown-menu .dropdown-item {
        font-size: 10px;
    }
    .signin-btn,
    .signout-btn {
        margin-right: 25px;
        font-size: 10px;
    }
    .logout-dropdown {
        font-size: 14px !important;
        margin-right: -25px !important;
        padding-left: 3px !important;
    }
    .signout-btn {
        margin-right: -10px !important;
        font-size: 14px !important;
    }
}
</style>
